// habitation/types.ts
export interface Address {
  street: string;
  postalCode: string;
  city: string;
  country: string;
}

export enum HousingType {'room', 'full'};


export enum FloorLevel {'ground', 'middle', 'top'};


export interface Roommate {
  civility: 'M' | 'Mme';
  firstname: string;
  lastname: string;
  birthdate: string;
}

export interface HabitationState {
  address: Address | null;
  step: number;
  lastVerifiedStep: number;
  floorLevel: FloorLevel | null;
  housingType: HousingType | null;
  roommates: Roommate[];
  numberOfRooms: number;
  startDate: string | null;
  price: number | null; 
  paymentType: 'mensuel' | 'annuel';
  contractReference: string | null;
  stripeConfigType: 'payment_intent' | null;
  subscriptionId: string | null;
  /** Slug d'école capturé depuis ?school=... à l'arrivée sur le parcours. */
  schoolName: string | null;
}

// Structure du DTO à envoyer côté back (HomeContractDTO)
export interface HomeContractPayload {
  startDate: string;
  endDate?: string;
  customerReference?: string;
  studentId?: string;

  address: Address;
  numberOfPersons: number;
  numberOfRooms: number;
  optionPayment: 'monthly' | 'annual';
  price: number;
  roommates: Roommate[];

  templateName: string;
  sessionStripe?: string;
  moveablecapital?: number;
  franchise1?: number;
  franchise2?: number;
  tax?: number;
}

// Structure des messages SSE pour la confirmation d'email
export interface EmailConfirmationMessage {
  status: 'confirmed' | 'pending' | 'error';
  active?: boolean;
  isVerified?: boolean;
}
